module.exports = __webpack_public_path__ + "img/Loc_h.78d5e934.svg";